import { defaultTheme } from "@hubrise/react-components"
import type { Theme } from "@hubrise/react-components"

import { ServerConfig } from "./config"

export const theme = (config: ServerConfig): Theme => ({
  colors: {
    ...defaultTheme.colors,
    primary: config.primaryColor ?? defaultTheme.colors.primary,
  },
})
